import { render, staticRenderFns } from "./accepted.vue?vue&type=template&id=2b38b1e2&scoped=true&"
import script from "./accepted.vue?vue&type=script&lang=js&"
export * from "./accepted.vue?vue&type=script&lang=js&"
import style0 from "./accepted.vue?vue&type=style&index=0&id=2b38b1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38b1e2",
  null
  
)

export default component.exports